
<div class="question-group  px-1">
	<slot />
</div>
